import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAccountStore } from '../../../components/Stores/accountStore';
import { ChevronButton } from '../../../components/UI-Elements/Buttons/ChevronButton';
import { useAllProducts } from '../../../hooks/useProducts';
import { AddNewProductDetailsSummary } from '../AddNewProductComponents.tsx/Screens/ProductSummary/AddNewProductDetailsSummary';
import { AddNewProductSummary } from '../AddNewProductComponents.tsx/AddNewProductSummarySection';
import { useMaterialsStore } from '../../../components/Stores/MaterialsStore';
import React from 'react';

const PRODUCT_DASHBOARD_PATH = '/products-dashboard';

export const ProductDashboardProductSummary = () => {
  const { productId } = useParams<{ productId: string }>();
  const { account } = useAccountStore();
  const { data } = useAllProducts(account.id);
  const [currentProductIndex, setCurrentProductIndex] = useState(0);
  const { materialsMap } = useMaterialsStore();
  const navigate = useNavigate();

  useEffect(() => {
    const setProductIndex = () =>
      data && setCurrentProductIndex(data.findIndex((product) => product.uuid === productId));

    setProductIndex();
  }, [data, productId]);

  return (
    <div className=" flex flex-col flex-1 h-full overflow-hidden  ">
      {data && currentProductIndex != -1 && (
        <div className="flex flex-col flex-1 gap-2 overflow-auto ">
          <ChevronProductToggle
            backToSummary={() => navigate(PRODUCT_DASHBOARD_PATH)}
            toggleNext={() => {
              setCurrentProductIndex(currentProductIndex + 1);
            }}
            togglePrev={() => {
              setCurrentProductIndex(currentProductIndex - 1);
            }}
            isNextDisabled={currentProductIndex === data.length - 1}
            isPrevDisabled={!currentProductIndex}
          />
          {data[currentProductIndex] && (
            <div className="flex flex-row flex-1 gap-4 overflow-auto">
              <div className="flex-1 bg-white shadow-custom overflow-hidden">
                <AddNewProductDetailsSummary
                  product={data[currentProductIndex]}
                  routeToModifyProduct={() => {
                    navigate(`/setting-product-create/${data[currentProductIndex].uuid}`);
                  }}
                  setProduct={() => {}}
                  mainTitle={data[currentProductIndex]?.name}
                />
              </div>
              <div className="flex flex-0  ">
                <AddNewProductSummary
                  materialsMap={materialsMap}
                  cancel={() => navigate('/dashboard')}
                  product={data[currentProductIndex]}
                  submit={() => {}}
                  isLoading={false}
                  isSubmitDisabled={true}
                  isEditable={false}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

interface ChevronProps {
  toggleNext: () => void;
  togglePrev: () => void;
  backToSummary: () => void;
  isNextDisabled?: boolean;
  isPrevDisabled?: boolean;
}

const ChevronProductToggle: React.FC<ChevronProps> = ({
  toggleNext,
  togglePrev,
  backToSummary,
  isNextDisabled = false,
  isPrevDisabled = false,
}) => {
  return (
    <div className="flex flex-row w-[70%]    gap-10">
      <div className="flex flex-row  ">
        <ChevronButton
          direction="left"
          onButtonClick={() => {
            backToSummary();
          }}
        />
        <p className=" content-center text-lg ">Back to products </p>
      </div>
      <div className="flex flex-1 justify-center gap-6">
        <div className="flex ">
          <ChevronButton
            direction="left"
            onButtonClick={() => {
              togglePrev();
            }}
            disabled={isPrevDisabled}
          />
          <p className=" content-center text-sm">Previous</p>
        </div>
        <div className="flex">
          <p className=" content-center text-sm"> Next product </p>
          <ChevronButton
            onButtonClick={() => {
              toggleNext();
            }}
            disabled={isNextDisabled}
          />
        </div>
      </div>
    </div>
  );
};
